import React from 'react';
import { useFormik, FormikProvider } from 'formik';
import { Container, Button } from 'theme-ui';
import * as Yup from 'yup';

import Form from 'components/core/Form';
import Spacer from 'elements/Spacer';
import useAuth from 'hooks/useAuth';
import { useHistory } from 'react-router-dom';

const Signup: React.FC = () => {
  const { signup } = useAuth();
  const history = useHistory();

  const registerForm = useFormik({
    initialValues: {
      username: '',
      email: '',
      password: '',
      confirmPassword: ''
    },
    validationSchema: Yup.object({
      username: Yup.string().required('Required'),
      email: Yup.string()
        .email('Invalid email address')
        .required('Required'),
      password: Yup.string().required('Required'),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
        .required('Required')
    }),
    onSubmit: async (values, { setFieldError, setSubmitting }) => {
      const { username, email, password } = values;
      const { error } = await signup(username, email, password);

      if (error) {
        setFieldError('username', error);
        setSubmitting(false);
        return;
      }

      return history.push('signup/confirm');
    }
  });

  return (
    <Container>
      <FormikProvider value={registerForm}>
        <Form>
          <Form.Error name="username" component="div" />
          <Form.Label>Username</Form.Label>
          <Form.Field type="text" name="username" placeholder="Username" />

          <Spacer size={4} />

          <Form.Label>Email</Form.Label>
          <Form.Error name="email" component="div" />
          <Form.Field type="email" name="email" placeholder="Email" />

          <Spacer size={4} />

          <Form.Label>Password</Form.Label>
          <Form.Error name="password" component="div" />
          <Form.Field type="password" name="password" placeholder="Password" />

          <Spacer size={4} />

          <Form.Label>Confirm Password</Form.Label>
          <Form.Error name="confirmPassword" component="div" />
          <Form.Field
            type="password"
            name="confirmPassword"
            placeholder="Confirm Password"
          />

          <Spacer size={4} />

          <Button type="submit" disabled={registerForm.isSubmitting}>
            Submit
          </Button>
        </Form>
      </FormikProvider>
    </Container>
  );
};

export default Signup;
